(function() {
  var VARIANT_ID = '01a1683a-3135-7809-8a86-1851ba938e74';
  var VARIANT_VIEW = 'bocc-59-ceo';
  var ASSIGNMENT_TIMEOUT_MS = 3000;

  function getAssignment() {
    return new Promise(function(resolve) {
      var startedAt = Date.now();

      function checkShoplift() {
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
          window.shoplift.isHypothesisActive(VARIANT_ID).then(resolve).catch(function() {
            resolve(false);
          });
          return;
        }

        if (Date.now() - startedAt >= ASSIGNMENT_TIMEOUT_MS) {
          resolve(false);
          return;
        }

        window.setTimeout(checkShoplift, 50);
      }

      checkShoplift();
    });
  }

  function getDestination(isVariant) {
    var url = new URL(window.location.href);
    var currentView = url.searchParams.get('view');

    if (isVariant && currentView !== VARIANT_VIEW) {
      url.searchParams.set('view', VARIANT_VIEW);
      return url.toString();
    }

    if (!isVariant && currentView === VARIANT_VIEW) {
      url.searchParams.delete('view');
      return url.toString();
    }

    return null;
  }

  function routeToAssignedHomepage(isVariant) {
    var destination = getDestination(isVariant);

    if (destination) {
      window.location.replace(destination);
    }

    return isVariant;
  }

  if (window.Shopify && window.Shopify.designMode) {
    window.bocc59HomepageExperiment = {
      ready: Promise.resolve(false)
    };
    return;
  }

  window.bocc59HomepageExperiment = {
    ready: getAssignment().then(routeToAssignedHomepage)
  };
})();
